import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class CounterpartiesGroupsApi extends ApiModule {
    constructor() {
        super(ModulesMap.COUNTERPARTIES_GROUPS, {
            entity: 'counterparties_groups',
        })
    }
}
